module.exports = __webpack_public_path__ + "res/7-img_reward_b.387d8d6ccd1fff2f2c5e0eaba657b464.png";